// src/components/TestimonialsSection.js
import "./testimonialsSection.css";
import React, { useState, useEffect, useRef } from 'react';

function TestimonialsSection() {
  const testimonials = [
    { text: '"Saffron House transformed our space into something truly remarkable! Their attention to detail and design expertise brought our vision to life beautifully. Highly recommended!"', author: '— Mr. Yogesh Kaushal', image: 'images\premium_photo-1661778812498-d56d7f09d1fd.avif' },
    { text: '"The creativity and professionalism of Saffron House are unmatched. Their innovative designs and seamless execution made our interiors stunning. Absolutely delighted!"', author: '— Mr Vaibhav Maheshwari', image: 'C:/Users/Saumya Bhardwaj/Downloads/testimonial-image1.avif' },
    { text: '"Saffron House has an incredible sense of style and functionality. They created a space that perfectly blends elegance and comfort. A truly outstanding experience!"', author: '— Dr Sodani', image: 'C:/Users/Saumya Bhardwaj/Downloads/testimonial-image1.avif' },
    { text: '"From concept to completion, Saffron House delivered beyond expectations. Their unique designs and quality craftsmanship make them the go-to for interior transformations!"', author: '— Mr Kandhari', image: 'C:/Users/Saumya Bhardwaj/Downloads/testimonial-image1.avif' },
    { text: '"Saffron House brought sophistication and warmth to our space with their expert designs. Their passion and dedication reflect in every corner. Couldnt be happier!"', author: '— Mr Singh', image: 'C:/Users/Saumya Bhardwaj/Downloads/testimonial-image1.avif' },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const intervalRef = useRef(null);
  const totalSlides = testimonials.length;

  useEffect(() => {
    startInterval();
    return () => clearInterval(intervalRef.current);
  }, [currentIndex]);

  const startInterval = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % totalSlides);
    }, 5000);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div className="testimonials">
      <h2 className="testimonials-title">Testimonials</h2>
      <p className="testimonials-subtitle">Voices from Our Transformed Spaces</p>
      <div
        className="testimonials-slider"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        onMouseEnter={() => clearInterval(intervalRef.current)}
        onMouseLeave={startInterval}
        >
        {testimonials.map((item, index) => (
          <div className="testimonial-item" key={index}>
            <img
              // src={item.image}
              src="images/Testimonials_placeholder_image.png"
              alt={`Testimonial ${index + 1}`}
              className="testimonials-image" />
            <div className="testimonial-text-author-container">
              <p className="testimonials-text">{item.text}</p>
              <p className="testimonials-author">{item.author}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="slider-dots">
        {testimonials.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
          ></span>
        ))}
      </div>
    </div>
  );
}

export default TestimonialsSection;
